import React from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import { FaExclamationTriangle } from 'react-icons/fa';

const CredentialsErrorPage = () => {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          py: 4
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            textAlign: 'center',
            width: '100%'
          }}
        >
          <FaExclamationTriangle
            style={{
              fontSize: 64,
              color: '#d32f2f',
              marginBottom: 24
            }}
          />

          <Typography variant="h4" component="h1" fontWeight="bold" gutterBottom>
            Configuration Required
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: 3, lineHeight: 1.6 }}
          >
            API credentials are required to use the application in development mode.
          </Typography>

          <Box sx={{ mb: 4 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Please ensure you have entered both API key and email address
            </Typography>
            <Typography variant="body2" color="text.secondary">
              If you continue to experience issues, please contact support
            </Typography>
          </Box>

          <Button
            variant="contained"
            size="large"
            fullWidth
            onClick={handleRetry}
            sx={{ height: 48, mb: 2 }}
          >
            Retry
          </Button>

          <Typography variant="caption" color="text.secondary">
            Need help? Contact your administrator
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default CredentialsErrorPage;
